module.exports = __webpack_public_path__ + "static/6031-8af0f1141dcdccdc478c559fe288aef7.png";